export abstract class AudioData
{
  abstract get numChannels():number;
  abstract get numFrames():number;
  get numSamples(){ return this.numChannels * this.numFrames }

  abstract set( channel:number, frame:number, sample:number):void
  setAll( frame:number, sample:number ):void
  {
    for ( let c = 0; c < this.numChannels; c++ )
    {
      this.set( c, frame, sample );
    }
  }

  abstract get( channel:number, frame:number ):number;

  copyTo( target:AudioData )
  {
    for ( let i = 0; i < this.numFrames; i++ )
    {
      for ( let c = 0; c < this.numChannels; c++ )
      {
        target.set( c, i, this.get( c, i ) );
      }
    }
  }
    
}